import angular from 'angular';
import uiRouter from 'angular-ui-router';
import transfersTableComponent from './transfersTable.component';
import transfersTableService from './transfersTable.service';
import transfersTableFilter from './transfersTable.filter';
import apiTransfersService from '../../api/transfers.service';
import sharedService from '../../services/shared.service';
import cacheService from '../../services/cache.service';
import moment from 'moment';

const transfersTableModule = angular.module('transfersTable', [
    uiRouter,
    sharedService,
    cacheService,
    apiTransfersService
  ])
  .constant('moment', moment)
  .component('transfersTable', transfersTableComponent)
  .service('transfersTableService', transfersTableService)
  .filter('transfersTableFilter', transfersTableFilter)
  .name;

export default transfersTableModule;



// WEBPACK FOOTER //
// ./client/app/common/transfersTable/transfersTable.js